// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"67":"4b1a9f19","107":"4d0eb754","116":"f8b821a7","125":"27b85e22","179":"f18ec034","512":"ad487d6c","540":"d7772133","675":"9520c37c","765":"9dbb78c9","781":"b37c060b","795":"cca3920c"}[chunkId] + ".js";
};